import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiClient = axios.create({
  baseURL: API_BASE_URL || undefined,
  withCredentials: true,
});

export const API_ENDPOINTS = {
  authLogin: '/api/auth/login',
  authLogout: '/api/auth/logout',
  authMe: '/api/auth/me',
  loginProtectionConfig: '/api/auth/login-protection/config',
  passwordResetConfig: '/api/auth/password-reset/config',
  passwordResetRequest: '/api/auth/password-reset/request',
  passwordResetVerify: '/api/auth/password-reset/verify',
  passwordResetConfirm: '/api/auth/password-reset/confirm',
  adminLoginActivity: '/api/admin/login-activity',
  adminLoginActivityCsv: '/api/admin/login-activity.csv',
  usageEvents: '/api/usage-events',
  adminUsageHistorySummary: '/api/admin/usage-history/summary',
  adminUsageHistoryUsers: '/api/admin/usage-history/users',
  adminUsageHistoryUserDetail: (userId: number | string) => `/api/admin/usage-history/users/${userId}`,
  contactSubjectOptions: '/api/contact/subject-options',
  contactConversations: '/api/contact/conversations',
  contactConversationDetail: (id: number | string) => `/api/contact/conversations/${id}`,
  contactConversationMessages: (id: number | string) => `/api/contact/conversations/${id}/messages`,
  contactMessageFeedback: (id: number | string) => `/api/contact/messages/${id}/feedback`,
  adminContactFaqDocuments: '/api/admin/contact-faq-documents',
  adminContactFaqDocument: (id: number | string) => `/api/admin/contact-faq-documents/${id}`,
  adminContactFaqDocumentDownload: (id: number | string) => `/api/admin/contact-faq-documents/${id}/download`,
  adminContactSubjectOptions: '/api/admin/contact-subject-options',
  adminContactSubjectOption: (id: number | string) => `/api/admin/contact-subject-options/${id}`,
  adminContactConversations: '/api/admin/contact/conversations',
  adminContactConversationDetail: (id: number | string) => `/api/admin/contact/conversations/${id}`,
  adminContactConversationsCsv: '/api/admin/contact/conversations.csv',
  files: '/api/files',
  upload: '/api/upload',
  deleteFile: (fileId: string) => `/api/files/${fileId}`,
  updateFile: (fileId: string) => `/api/files/${fileId}`,
  analyze: '/api/analyze',
  chat: '/api/chat',
  status: '/api/status',
};

export default API_BASE_URL;
